import React, { useEffect } from 'react';
import axios from 'axios';
import Sidebar, { TrescMenu } from '../Components/Sidebar';
import { Routes, Route, Navigate } from 'react-router-dom';

import {
  Flex,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  Image,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FaBars } from 'react-icons/fa';
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM } from "../Theme/styles";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { registerSignOut } from '../sessionGuard';
import BoardPage from './Board';
import { MY_TASKS_PATH, PROJECT_STATUS_PATH, ROADMAP_PATH, ACTIVITY_PATH, LOGS_PATH, TASK_PATH } from '../categories';
import TaskLink from './TaskLink';
import ProjectStatus from './ProjectStatus';
import Activity from './Activity';
import Logs from './Logs';
import Roadmap from './Roadmap';
import { isRainbowUser } from '../rainbow';

const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const signOut = useSignOut();

  useEffect(() => {
    registerSignOut(signOut);
  }, [signOut]);

  useEffect(() => {
    axios.get(`${API_URL}/verify`, {
            withCredentials: true,
      headers: {
      'Authorization': `Bearer ${getToken()}`
      }
    }).then(res => {
      console.log(res.data);
      localStorage.setItem("nickname", res.data.user.nickname);
      localStorage.setItem("avatar", res.data.user.avatar);
      localStorage.setItem("roles", res.data.user.roles);
      localStorage.setItem("role", res.data.user.role || "developer");
      localStorage.setItem("team", res.data.user.team || "");
      localStorage.setItem("id", res.data.user.id);
      localStorage.setItem("rainbow", res.data.user.rainbow ? "1" : "0");
      localStorage.setItem("logs", res.data.user.logs ? "1" : "0");
      document.body.classList.toggle("rainbow", isRainbowUser());
    }).catch(err => {
      console.log(err);
    });
  }, [])

  useEffect(() => {
    document.body.classList.toggle("rainbow", isRainbowUser());
    return () => document.body.classList.remove("rainbow");
  }, [])

  return (
    <Flex
      w="100%"
      h={{ base: "auto", md: "100vh" }}
      minH={{ base: "100vh", md: "auto" }}
      overflow={{ base: "visible", md: "hidden" }}
      direction={"row"}
      bg="transparent"
      color={FORUM.tekst}
    >
      <Sidebar />

      <Drawer isOpen={isOpen} placement={"left"} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent maxW={"260px"} bg={FORUM.tlo}>
          <TrescMenu onWybor={onClose} />
        </DrawerContent>
      </Drawer>
      <Flex
        direction="column"
        p={{ base: 3, md: 4 }}
        flex={"1"}
        minW={0}
        minH={0}
        overflow={{ base: "visible", md: "hidden" }}
      >
        <Flex
          display={{ base: "flex", md: "none" }}
          align={"center"}
          gap={2}
          mb={3}
          flexShrink={0}
        >
          <IconButton
            aria-label={"Menu"}
            icon={<FaBars />}
            onClick={onOpen}
            variant={"drugorzedny"}
            size={"sm"}
          />
          <Image src="./logo.svg" alt="" height={"20px"} />
          <Text fontSize={"sm"} fontWeight={"600"} color={FORUM.tekstJasny}>
            socialproject.pl
          </Text>
        </Flex>
        <Routes>
          <Route path="moje" element={<BoardPage onlyMine />} />
          <Route path={PROJECT_STATUS_PATH.slice(1)} element={<ProjectStatus />} />
          <Route path={ROADMAP_PATH.slice(1)} element={<Roadmap />} />
          <Route path={ACTIVITY_PATH.slice(1)} element={<Activity />} />
          <Route path={LOGS_PATH.slice(1)} element={<Logs />} />
          <Route path={TASK_PATH.slice(1) + "/:taskId"} element={<TaskLink />} />
          <Route path=":category" element={<BoardPage />} />
          <Route path="/" element={<Navigate to={MY_TASKS_PATH} replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Flex>
    </Flex>
  );
};

const NotFound = () => {
  return (
    <div>
      <h1>404 - Not Found</h1>
    </div>
  );
};

export default Home;